import React from 'react';
import { Button } from '../UI/Button/Button';
import SidebarItem from './SidebarItem';
import SidebarSection from './SidebarSection';
import styles from '../styles/menu.module.scss';
import { useI18n } from '../../features/i18n/useI18n';

export const Sidebar: React.FC = () => {
  const { t } = useI18n();
  
  return (
    <aside className={styles.sidebar}>
      <div className={styles.topSection}>
        <Button variant="create" icon="more" fullWidth>
          Create
        </Button>
        <SidebarItem icon="home" text={t("list_menu.list_menu_initial")} to="/" />
        <SidebarItem icon="reindex" text={t("list_menu.list_menu_assignments")} to="/assignments" />
        <SidebarItem icon="project" text={t("list_menu.list_menu_iproject")} to="/projects" />
        <SidebarItem icon="report" text="Inbox" badge="dot" to="/inbox" />
      </div>

      <SidebarSection title="Projects" actionIcon="more">
        <SidebarItem icon="project" text="Project 1" color="#A9DCD9" to="/projects/1" />
        <SidebarItem icon="project" text="Project 2" color="#FFC7D8" to="/projects/2" />
      </SidebarSection>

      <SidebarSection title="Team">
        <SidebarItem icon="configuration" text={t("list_menu.list_menu_admin")} to="/admin" />
      </SidebarSection>

      <SidebarSection title="Insights">
        <SidebarItem icon="reindex" text="Reporting" to="/reporting" />
        <SidebarItem icon="tracker" text="Portfolios" to="/portfolios" />
        <SidebarItem icon="user" text="Goals" to="/goals" />
      </SidebarSection>

      <div className={styles.bottomSection}>
        <SidebarItem icon="user" text="Invite" to="/invite" />
        <SidebarItem icon="report" text="Help" to="/help" />
      </div>
    </aside>
  );
};

export default Sidebar; 